export const staticAPI = 'http://static.aehip.com';
export const API = process.env.REACT_APP_API_URL;
export const ABLY_API_KEY = process.env.REACT_APP_ABLY_API_KEY;
